import type { CSSProperties } from 'react'
import { team } from '@/config/team'

export const TeamSection = () => (
  <section id="team" className="x-team" aria-labelledby="team-title">
    <div className="x-wrap">
      <div className="x-team-head">
        <p className="x-eyebrow x-eyebrow--ink">Team</p>
        <h2 id="team-title" className="x-h2">
          Who you’d be building with
        </h2>
      </div>
      <div className="x-people">
        {team.map((person) => (
          <article key={person.name} className="x-person">
            <div className="x-portrait" style={{ '--slice': person.slice } as CSSProperties}>
              <img src={person.photo} alt={`Portrait of ${person.name}`} width={960} height={768} loading="lazy" decoding="async" />
            </div>
            <h3>{person.name}</h3>
            <p className="x-role">{person.role}</p>
            <p>{person.bio}</p>
          </article>
        ))}
      </div>
    </div>
  </section>
)
